import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Optional } from '../../shared/shared.types';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private static readonly PROFILE_KEY = 'Profile';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): Profile {
    return this.storage.get(ProfileService.PROFILE_KEY);
  }

  public set(profile: Profile) {
    this.formatProfile(profile);
    this.storage.set(ProfileService.PROFILE_KEY, profile);
  }

  public remove() {
    this.storage.remove(ProfileService.PROFILE_KEY);
  }

  private formatProfile(profile: Profile): void {
    profile.anrede = profile.anrede ? (profile.anrede?.slice(0, 1) + profile.anrede?.slice(1).toLowerCase())
      : profile.anrede;
  }
}

export interface Profile {
  givenName: string;
  familyName: string;
  anrede: Optional<string>;
}
